<template>
  <section>
    <h2 v-if="columns.length">
      Reporting by Country
    </h2>
    <div class="container country-widgets-list">
      <!--<div class="col" v-for="(column, idx) in columns" :key="idx">-->
      <div class="col columns is-multiline is-mobile">
        <div
          class="item-container country-widgets column is-6-mobile is-3-tablet is-3-desktop is-6-fullhd"
          v-for="(row, idx) in columns"
          :key="idx"
        >
          <div class="card dashboard-report-by-country">
            <div class="card-content media is-mobile">
              <div class="media-content">
                <div
                  class="country-data clickable"
                  @click="navigateToReportingTracker(row.id)"
                >
                  <country-flag :country="row.code" size="normal" /> <br />
                  {{ row.code }}
                </div>
              </div>
              <div class="media-right">
                <div class="completion-counts">
                  <div
                    class="completion-percent"
                    v-if="row.report_completion_percent != 100"
                  >
                    {{ row.report_completion_percent }}%
                  </div>
                  <div v-else>
                    <b-icon
                      icon="check-bold"
                      type="is-success"
                      size="is-medium"
                    ></b-icon>
                  </div>
                  <div class="completed-in-count">
                    {{ row.completed_reports }}/{{ row.total_reports }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DashboardDataService from "../../services/DashboardDataService";
// @group Dashboard
export default {
  name: "ReportByCountry",
  props: {
    records: {
      type: Array
    }
  },
  data() {
    return {
      dashboardDataService: new DashboardDataService(),
      cols: 4
    };
  },
  computed: {
    columns() {
      const avg = this.records.length / parseFloat(this.cols);
      const output = [];
      let last = 0.0;

      while (last < this.records.length) {
        output.push(this.records.slice(parseInt(last), parseInt(last + avg)));
        last += avg;
      }

      const sortedResult = output.sort(function(a, b) {
        return b.length - a.length;
      });

      return this.arrayToObject(sortedResult, "code");
    }
  },
  methods: {
    arrayToObject(arr, key) {
      const res = [];
      arr.forEach(obj => {
        obj.forEach(obj2 => {
          if (obj2[key]) res.push(obj2);
        });
      });
      return res;
    },
    navigateToReportingTracker(countryCode) {
      // Navigate to reporting tracker with country filter
      this.$router.push({
        name: "reportingtracker",
        query: { country: countryCode }
      });
    }
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
  transition: opacity 0.2s;
}

.clickable:hover {
  opacity: 0.8;
}
</style>
